import { AssetConfig } from '@/config/assets-config'
import logoMobile from '@/features/assets/unitedslots/logo_mobile.svg'
import logoDesktop from '@/features/assets/unitedslots/logo_desktop.svg'
import competition from '@/features/assets/unitedslots/store/competition.png?w=55;110;220&as=srcset&imagetools'
import postal from '@/features/assets/unitedslots/store/postal.png?w=55;110;220&as=srcset&imagetools'
import social from '@/features/assets/unitedslots/store/social.png?w=55;110;220&as=srcset&imagetools'
import specialOffer from '@/features/assets/unitedslots/store/special-offer.png?w=30;60;120&as=srcset&imagetools'
import singleSC from '@/features/assets/unitedslots/store/single-sc.png?w=100;200;300&as=srcset&imagetools'

import CoinGC_sm from '@/features/assets/unitedslots/coin-gc_sm.png?w=100;200;300&as=srcset&imagetools'
import CoinGC_md from '@/features/assets/unitedslots/coin-gc_md.png?w=100;200;300&as=srcset&imagetools'
import CoinGC_chest from '@/features/assets/unitedslots/coin-gc_chest.png?w=100;200;300&as=srcset&imagetools'

import CoinSC_sm from '@/features/assets/unitedslots/coin-sc_sm.png?w=100;200;300&as=srcset&imagetools'
import CoinSC_md from '@/features/assets/unitedslots/coin-sc_md.png?w=100;200;300&as=srcset&imagetools'
import CoinSC_chest from '@/features/assets/unitedslots/coin-sc_chest.png?w=100;200;300&as=srcset&imagetools'

import CoinGCSC_sm from '@/features/assets/unitedslots/coin-gc-sc_sm.png?w=100;200;300&as=srcset&imagetools'
import CoinGCSC_md from '@/features/assets/unitedslots/coin-gc-sc_md.png?w=100;200;300&as=srcset&imagetools'
import CoinGCSC_chest from '@/features/assets/unitedslots/coin-gc-sc_chest.png?w=100;200;300&as=srcset&imagetools'

import Page_404 from '@/features/assets/unitedslots/404.png?w=148;296;444&as=srcset&imagetools'
import Geoblock from '@/features/assets/unitedslots/geoblock.png?w=148;296;444&as=srcset&imagetools'
import loaderAnimation from '@/features/assets/unitedslots/loader-animation.json'

import gcStack_md from '@/features/assets/unitedslots/gc-stack_md.png?w=100;200;300&as=srcset&imagetools'

import accountBank from '@/features/assets/unitedslots/account-bank.png?w=36;72;108&as=srcset&imagetools'
import discussion from '@/features/assets/unitedslots/discussion.png?w=36;72;108&as=srcset&imagetools'
import lock from '@/features/assets/unitedslots/lock.png?w=36;72;108&as=srcset&imagetools'
import shield from '@/features/assets/unitedslots/shield.png?w=36;72;108&as=srcset&imagetools'

import gift1 from '@/features/assets/unitedslots/gifts/gift-1.png?w=100;200;300&as=srcset&imagetools'
import gift2 from '@/features/assets/unitedslots/gifts/gift-2.png?w=100;200;300&as=srcset&imagetools'
import gift3 from '@/features/assets/unitedslots/gifts/gift-3.png?w=100;200;300&as=srcset&imagetools'

import smallBackground from '@/features/assets/unitedslots/small-bg.png'

import playForFree1UnitedSlotsBannerFull from '@/features/assets/unitedslots/default-hero-banner/play-for-free-1-unitedslots.webp?w=960;1440&as=srcset&imagetools'
import havingFunUnitedSlotsBannerFull from '@/features/assets/unitedslots/default-hero-banner/having-fun-unitedslots.webp?w=960;1440&as=srcset&imagetools'
import hotSpinsUnitedSlotsBannerFull from '@/features/assets/unitedslots/default-hero-banner/hot-spins-unitedslots.webp?w=960;1440&as=srcset&imagetools'
import playForFree2UnitedSlotsBannerFull from '@/features/assets/unitedslots/default-hero-banner/play-for-free-2-unitedslots.webp?w=960;1440&as=srcset&imagetools'

import playForFree1UnitedSlotsBannerThumb from '@/features/assets/unitedslots/default-hero-banner/play-for-free-1-unitedslots-thumb.webp'
import havingFunUnitedSlotsBannerThumb from '@/features/assets/unitedslots/default-hero-banner/having-fun-unitedslots-thumb.webp'
import hotSpinsUnitedSlotsBannerThumb from '@/features/assets/unitedslots/default-hero-banner/hot-spins-unitedslots-thumb.webp'
import playForFree2UnitedSlotsBannerThumb from '@/features/assets/unitedslots/default-hero-banner/play-for-free-2-unitedslots-thumb.webp'

import entryRequest from '@/features/assets/unitedslots/out-of-tokens/entry-request.png?w=40;80;120&as=srcset&imagetools'
import dailyBonus from '@/features/assets/unitedslots/out-of-tokens/daily-bonus.png?w=40;80;120&as=srcset&imagetools'
import socialContest from '@/features/assets/unitedslots/out-of-tokens/social-contest.png?w=40;80;120&as=srcset&imagetools'
import freeGift from '@/features/assets/unitedslots/out-of-tokens/free-gift.png?w=96;192;288&as=srcset&imagetools'
import buyGc from '@/features/assets/unitedslots/out-of-tokens/buy-gc.png?w=40;80;120&as=srcset&imagetools'

import spinningGoldCoins from '@/features/assets/unitedslots/spinning_gold_coin.gif'
import spinningSweepsCoins from '@/features/assets/unitedslots/spinning_sweeps_coin.gif'

import genericError from '@/features/assets/unitedslots/generic-error.png?w=60;120;240&as=srcset&imagetools'

import accessControlsConfirmationTick from '@/features/assets/unitedslots/tick.png?w=74;148;296&as=srcset&imagetools'

import questsOnboardingJoin from '@/features/assets/unitedslots/quests-onboarding-join.webp'
import questsOnboardingPlay from '@/features/assets/unitedslots/quests-onboarding-play.webp'
import questsOnboardingClaim from '@/features/assets/unitedslots/quests-onboarding-claim.webp'

import bell from '@/features/assets/unitedslots/bell.png?w=48;96;144&as=srcset&imagetools'

const ASSETS_BRAND_CONFIGS: AssetConfig = {
  animations: {
    loader: loaderAnimation,
    spinningCoins: {
      gc: spinningGoldCoins,
      sc: spinningSweepsCoins,
    },
  },
  accountBank: accountBank,
  discussion: discussion,
  gifts: {
    gift1: gift1,
    gift2: gift2,
    gift3: gift3,
  },
  lock: lock,
  bell: bell,
  shield: shield,
  logo: {
    mobile: logoMobile,
    desktop: logoDesktop,
  },
  store: {
    competition: competition,
    postal: postal,
    social: social,
    specialOffer: specialOffer,
    singleSC: singleSC,
  },
  coins: {
    gc: {
      sm: CoinGC_sm,
      md: CoinGC_md,
      chest: CoinGC_chest,
    },
    sc: {
      sm: CoinSC_sm,
      md: CoinSC_md,
      chest: CoinSC_chest,
    },
    gc_sc: {
      sm: CoinGCSC_sm,
      md: CoinGCSC_md,
      chest: CoinGCSC_chest,
    },
  },
  stacks: {
    gc: {
      md: gcStack_md,
    },
  },
  backgroundImages: {
    smallBackground: smallBackground,
  },
  page404: Page_404,
  geoblock: Geoblock,
  outOfTokens: {
    entryRequest: entryRequest,
    dailyBonus: dailyBonus,
    socialContest: socialContest,
    freeGift: freeGift,
    buyGc: buyGc,
  },
  heroBanner: {
    firstBannerFull: playForFree1UnitedSlotsBannerFull,
    secondBannerFull: havingFunUnitedSlotsBannerFull,
    thirdBannerFull: hotSpinsUnitedSlotsBannerFull,
    fourthBannerFull: playForFree2UnitedSlotsBannerFull,
    firstBannerThumb: playForFree1UnitedSlotsBannerThumb,
    secondBannerThumb: havingFunUnitedSlotsBannerThumb,
    thirdBannerThumb: hotSpinsUnitedSlotsBannerThumb,
    fourthBannerThumb: playForFree2UnitedSlotsBannerThumb,
  },
  genericError,
  accessControlsConfirmationTick,
  questsOnboardingAssets: {
    join: questsOnboardingJoin,
    play: questsOnboardingPlay,
    claim: questsOnboardingClaim,
  },
}

export default ASSETS_BRAND_CONFIGS
